document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".js-tab-link");
  const panels = document.querySelectorAll(".js-tab-panel");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {

      const targetPanel = this.getAttribute("aria-controls");

      tabs.forEach(t => {
        t.classList.remove("active");
        t.setAttribute("aria-selected", "false");
      });

      panels.forEach(panel => {
        panel.classList.remove("active");
        panel.setAttribute("hidden", true);
      });

      this.classList.add("active");
      this.setAttribute("aria-selected", "true");

      const panel = document.getElementById(targetPanel);
      panel.classList.add("active");
      panel.removeAttribute("hidden");
    });
  });
});